import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { createFeedback, getListFeedback, updFeedback } from "../../services/feedbackService";

const initialState = {
  filter: {
    status: null,
    type: null
  },
  sort: {
    sort_by: 'createdAt',
    sort: 'desc'
  },
  feedbackSelected: undefined
};

export const feedbackSlice = createSlice({
  name: "feedback",
  initialState,
  reducers: {
    changeFilter: (state, action: any) =>
    {
      state.filter = action.payload;
    },

    changeSort: (state, action: any) =>
    {
      state.sort = action.payload;
    },

    reset: (state) =>
    {
      state.sort.sort = 'desc';
      state.sort.sort_by = 'createdAt';
      state.filter.status = null;
      state.filter.type = null

    },
    changeFeedbackSelected: (state, action: any) =>
    {
      state.feedbackSelected = action.payload;
    },
  },
});

export const getListFeedbackAsync = createAsyncThunk(
  "feedback/getListFeedback",
  async (payload: any) =>
  {
    try
    {

      const response = await getListFeedback(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const createFeedbackAsync = createAsyncThunk(
  "feedback/createFeedback",
  async (payload: any) =>
  {
    try
    {
      const response = await createFeedback(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const updFeedbackAsync = createAsyncThunk(
  "feedback/updFeedback",
  async (payload: any) =>
  {
    try
    {
      const response = await updFeedback(payload);
      return response;
    } catch (e: any)
    {
      console.log(e, "error");

      return {
        message: e?.response?.data?.message,
      };
    }
  }
);

export const {
  changeFilter,
  changeSort,
  reset,
  changeFeedbackSelected
} = feedbackSlice.actions;

export default feedbackSlice.reducer;
